import ContactSection from "../components/ContactSection";

export default function Contact() {
  return <ContactSection />;
}
